module.exports = __webpack_public_path__ + "static/media/majorA6.cd43b88.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorA6.wav
// module id = Qw/e
// module chunks = 0